import './DivineBadge.css';

export default function DivineBadge() {
  const isLocal = window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';
  const href = isLocal ? '/' : 'https://divinepleasure.cz';

  return (
    <a className="divine-badge" href={href} title="Divine Pleasure">
      <img src={`${process.env.PUBLIC_URL}/Logo2.svg`} alt="Divine Pleasure" />
    </a>
  );
}
